module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3f5201aea12f282cdb6edd2575fef169.jpg";